import { createApp } from 'vue'
import App from './App.vue'
import 'vant/lib/index.css';
import router from './router'

import { createI18n } from 'vue-i18n'

const messages = {
    cn: {
        message: {
            title: '售后管理平台',
            help: '常用帮助',
            reg: '售服注册',
            report: '质检报告',
            service: '售后服务',
            tips1: '请选择您的角色进入',
            tips2: '我是客户/经销商',
            tips3: '我是售后服务人员',
            sales: '售后',
            log: '日志',
            maintenance: '日常保养',
            deviceMaintenance: '设备保养',
            tel: '服务热线',
            accountVerification: '账号验证',
            tips4: '请输入手机号',
            tips5: '未找到设备信息',
            tips6: '验证失败，该设备未分配给您',
            tips7: '验证成功',
            tips8: '验证失败，该手机号暂无权限',
            tips9: '当前设备已无执行保养项',

            help2: '使用帮助',
            tips10: '*异常问题如无法解决，请联系代理商工程师协助解决*',

            salesList: '售后列表',
            noMore: '没有更多了',
            model: '设备型号',
            no: '设备编号',
            search: '查看',
            edit: '编辑',
            back: '返回',

            tips11: '售服注册申请',
            company: '所属公司',
            tips12: '请选择所属公司',
            tips13: '请填写',
            phone: '手机号',
            tips14: '请输入手机号',
            nickName: '昵称',
            tips15: '请输入昵称',
            saveIng: '保存中...',
            tips16: '注册申请',
            tips: '提示',
            tips17: '是否提交?',
            tips18: '提交申请成功',

            salesLog: '售后日志',
            today: '今日完成',
            tips19: '请输入',
            image: '图片',
            video: '视频',
            tomorrow: '明日计划',
            client: '客户',
            logList: '日志列表',
            confirm: '确 定',
            tips20: '选择日期',
            tips21: '添加成功',
            uploading: '上传中...',
            productionDate: '出厂日期',
            detail: '详情',

            logDetail: '日志详情',
            me: '我',
            reply: '回复',
            to: '的',
            comment: '评论',
            replySuccess: '回复成功',

            salesService: '售后服务单',
            customerFeedback: '客户反馈',
            solution: '解决方案',
            time: '解决时间',
            charge: '是否收费？',
            yse: '是',
            no2: '否',
            signature: '客户签字',
            draft: '草稿',
            problem: '问题',
            category: '问题类别',
            description: '问题描述',
            analysis: '问题分析',
            plan: '处理方案',
            result: '处理结果',
            accessory: '配件',
            remark: '备注',
            tips22: '请上传至少一张图片',
            feedback: '反馈人',
            voice: '语音',
            confirmSubmit: '确认提交',
            next: '下一步',
            complete: '完成服务',
            tips23: '完成服务，是否收费',
            reset: '重置',
            tips24: '请先完成反馈信息',
            isDel: '确定删除吗?',
            tips25: '删除成功',
            tips26: '请至少保存一条解决方案',
            tips27: '请签字',
            save: '保存',

            equipmentMaintenance: '设备保养',
            maintainer: '保养人',
            interval: '保养周期',
            expirationTime: '到期时间',
            description2: '项目说明',
            day: '天',
            perform: '执行保养',
            tips28: '是否确认执行保养?',
            tips29: '执行成功',
            tips30: '当前设备已无执行保养项',
            language: '当前语言',


        }
    },
    en: {
        message: {
            title: 'After Sales',
            help: 'Help',
            reg: 'Reg',
            report: 'Report',
            service: 'Service',
            tips1: 'Please select your character to enter',
            tips2: 'I am a customer/distributor',
            tips3: 'service personnel',
            sales: 'Sales',
            log: 'Log',
            maintenance: 'Maintenance',
            deviceMaintenance: 'Device Maintenance',
            tel: 'Tel',
            accountVerification: 'Account Verification',
            tips4: 'Please enter your phone number',
            tips5: 'Device information not found',
            tips6: 'Device information not found',
            tips7: 'Verification successful',
            tips8: 'No permission temporarily',
            tips9: 'The current device has no maintenance items to perform',

            help2: 'Help',
            tips10: '*If the abnormal problem cannot be solved, please contact the agent engineer for assistance in resolving it*',

            salesList: 'Sales List',
            noMore: 'No More',
            model: 'Model',
            no: 'No',
            search: 'Search',
            edit: 'Edit',
            back: 'Back',

            tips11: 'Reg',
            company: 'Company',
            tips12: 'Please select your company',
            tips13: 'Please Fill in',
            phone: 'Phone',
            tips14: 'Please enter your phone',
            nickName: 'Nick Name',
            tips15: 'Please enter a nickname',
            saveIng: 'Saving...',
            tips16: 'Reg',
            tips: 'Tips',
            tips17: 'Submit?',
            tips18: 'Successfully',

            salesLog: 'sales Log',
            today: 'Today',
            tips19: 'Please Input',
            image: 'Image',
            video: 'Video',
            tomorrow: 'Tomorrow',
            client: 'Client',
            logList: 'Log List',
            confirm: 'Confirm',
            tips20: 'Select Date',
            tips21: 'Added successfully',
            uploading: 'Uploading...',
            productionDate: 'Prod Date',
            detail: 'Detail',

            logDetail: 'Log Detail',
            me: 'Me',
            reply: 'Reply',
            to: 'To',
            comment: 'Comment',
            replySuccess: 'Reply Success',

            salesService: 'Sales Service',
            customerFeedback: 'Feedback',
            solution: 'Solution',
            time: 'Time',
            charge: 'Charge？',
            yse: 'Yse',
            no2: 'No',
            signature: 'Signature',
            draft: 'Draft',
            problem: 'Problem',
            category: 'Category',
            description: 'Description',
            analysis: 'Analysis',
            plan: 'Plan',
            result: 'Result',
            accessory: 'Accessory',
            remark: 'Remark',
            tips22: 'Please upload at least one image',
            feedback: 'Person',
            voice: 'Voice',
            confirmSubmit: 'Submit',
            next: 'Next',
            complete: 'Complete',
            tips23: 'Complete，Charge?',
            reset: 'Reset',
            tips24: 'Please complete the feedback information first',
            isDel: 'Are you sure to delete it?',
            tips25: 'Successfully deleted',
            tips26: 'Please save at least one solution',
            tips27: 'Please sign',
            save: 'Save',

            equipmentMaintenance: 'Equipment Maintenance',
            maintainer: 'Maintainer',
            interval: 'Interval',
            expirationTime: 'Expiration Time',
            description2: 'Description2',
            day: 'Day',
            perform: 'Perform',
            tips28: 'Are you sure to perform maintenance?',
            tips29: 'Execution succeeded',
            tips30: 'The current device has no maintenance items to perform',
            language: 'Current Language',
        }
    }
}

const i18n = createI18n({
    locale: 'en', // 当前语言
    fallbackLocale: 'en', // 回退语言
    messages,
    legacy: false,
})

const app = createApp(App)
app.use(i18n)
app.use(router)
app.mount('#app')

